'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../Icon/Icon.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-avatar',
    cnLoggedIn = "".concat(CLASSNAME, "--logged-in"),
    cnNoImage = "".concat(CLASSNAME, "--no-image"),
    cnProfileImage = "".concat(CLASSNAME, "__profile-image"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnInitials = "".concat(CLASSNAME, "__initials"),
    cnEdit = "".concat(CLASSNAME, "__edit"),
    cnEditIcon = "".concat(cnEdit, "__icon");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function Avatar(props) {
  var _classNames;

  var className = props.className,
      color = props.color,
      edit = props.edit,
      firstName = props.firstName,
      image = props.image,
      lastName = props.lastName,
      size = props.size;
  var loggedIn = firstName || lastName;

  function getInitials() {
    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var ln = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return [fn, ln].map(function (a) {
      var _a$;

      return (_a$ = a[0]) === null || _a$ === void 0 ? void 0 : _a$.toUpperCase();
    }).join('');
  }

  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: !image ? color : null
    },
    className: classNames(CLASSNAME, className, "".concat(CLASSNAME, "--").concat(size), (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, cnLoggedIn, loggedIn), _rollupPluginBabelHelpers.defineProperty(_classNames, cnNoImage, !image && loggedIn), _classNames))
  }, edit && /*#__PURE__*/React__default.createElement("div", {
    className: cnEdit
  }, /*#__PURE__*/React__default.createElement(Icon, {
    className: cnEditIcon,
    id: "user",
    size: size
  })), image ? /*#__PURE__*/React__default.createElement("div", {
    className: cnProfileImage,
    style: {
      backgroundImage: "url(".concat(image, ")")
    }
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: cnProfileImage
  }, loggedIn ? /*#__PURE__*/React__default.createElement("span", {
    className: cnInitials
  }, !edit && getInitials(firstName, lastName)) : /*#__PURE__*/React__default.createElement(Icon, {
    className: cnIcon,
    id: "user",
    size: "xs"
  })));
}
Avatar.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Custom color of user */
  color: PropTypes.string,

  /** If `true`, an edit-CTA will be displayed */
  edit: PropTypes.bool,

  /** Firstname of user */
  firstName: PropTypes.string,

  /** URL to profile image */
  image: PropTypes.string,

  /** Lastname of user */
  lastName: PropTypes.string,

  /** Size code enum */
  size: PropTypes.oneOf(['xxs', 'xs', 'sm', 'md', 'lg', 'xl'])
};
Avatar.defaultProps = {
  size: 'lg'
};

module.exports = Avatar;
